import { NAME } from './reducer'

export const getLoginState = state => state[NAME]
export const getToken = state => getLoginState(state).token
export const getPermissions = state => getLoginState(state).permissions
